export const productList = [
  {
    id: "hyperx-cloud-mix",
    name: "HyperX Cloud Mix",
    preview: require("@/assets/img/prizes/2021/promoaction/hyperx-cloud-mix-preview.png")
  },
  {
    id: "hyperx-cloud-orbit",
    name: "HyperX Cloud Orbit",
    preview: require("@/assets/img/prizes/2021/promoaction/hyperx-cloud-orbit-preview.png")
  },
  {
    id: "hyperx-cloud-orbit-s",
    name: "HyperX Cloud Orbit&nbsp;S",
    preview: require("@/assets/img/prizes/2021/promoaction/hyperx-cloud-orbit-s-preview.png")
  },
  {
    id: "hyperx-alloy-elite-2",
    name: "HyperX Alloy Elite 2",
    preview: require("@/assets/img/prizes/2021/promoaction/hyperx-alloy-elite-2-preview.png")
  },
  {
    id: "hyperx-fury-ultra",
    name: "HyperX Fury Ultra",
    preview: require("@/assets/img/prizes/2021/promoaction/hyperx-fury-ultra-preview.png")
  },
  {
    id: "hyperx-pulsefire-dart",
    name: "HyperX Pulsefire Dart",
    preview: require("@/assets/img/prizes/2021/promoaction/hyperx-pulsefire-dart-preview.png")
  },
  {
    id: "hyperx-pulsefire-raid",
    name: "HyperX Pulsefire Raid",
    preview: require("@/assets/img/prizes/2021/promoaction/hyperx-pulsefire-raid-preview.png")
  },
  {
    id: "hyperx-pulsefire-fps-pro",
    name: "HyperX Pulsefire FPS Pro",
    preview: require("@/assets/img/prizes/2021/promoaction/hyperx-pulsefire-fps-pro-preview.png")
  }
];
